import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function PublicLayout() {
  return (
    <div className="flex h-screen">
      <div className="flex flex-col flex-1">
        <Navbar />
        {/* Page content goes here */}
        <main className="p-4">
          <Outlet /> {/* <- renders child routes */}
        </main>
      </div>
    </div>
  );
}